import { useState, useEffect, useCallback } from 'react';
import { Range, getTrackBackground } from 'react-range';
import PropTypes from 'prop-types';
import styles from './MinMaxFilter.module.scss';
import { PRICE_FILTER_DEFAULT } from '@/constants/categ';

const COLORS = {
  primary: '#000',
  secondary: '#D6D6D6'
};

const MinMaxFilter = (
  {
    values = [PRICE_FILTER_DEFAULT.min, PRICE_FILTER_DEFAULT.max],
    min = PRICE_FILTER_DEFAULT.min,
    max = PRICE_FILTER_DEFAULT.max,
    step = PRICE_FILTER_DEFAULT.step,
    handleRangeOnChange
  }
) => {
  const [currentValue, setCurrentValue] = useState(values);
  const [thumbIsHover, setThumbIsHover] = useState(false);

  useEffect(() => {
    setCurrentValue(values);
  }, [values]);

  const renderTrack = useCallback(({ props, children }) => (
    <div className={styles['outer-main-line-custom']}
      style={{
        ...props.style,
        background: getTrackBackground({
          values: currentValue,
          colors: [COLORS.secondary, COLORS.primary, COLORS.secondary],
          min,
          max
        })
      }}
      aria-label="track"
    >
      <div className={styles['inner-main-line-custom']}
        ref={props.ref}
      >
        {children}
      </div>
    </div>
  ), [currentValue]);

  const renderThumb = useCallback(({ props, isDragged }) => (
    <div className={styles['outer-cursor-custom']}
      {...props}
      style={{
        ...props.style,
        ...MinMaxFilter.styles.thumb
      }}
      onMouseEnter={() => setThumbIsHover(true)}
      onMouseLeave={() => setThumbIsHover(false)}
      aria-label="thumb"
    >
      <div className={styles['inner-cursor-custom']}
        style={{
          cursor: isDragged ? 'grabbing' : 'pointer'
        }}
      />
    </div>
  ), [thumbIsHover]);

  const customOnChange = (values) => {
    setCurrentValue(values);
    handleRangeOnChange(values, false);
  };

  return (
    <div className={styles.container}>
      <Range
        className="form-check-input"
        min={min}
        max={max}
        step={step}
        values={currentValue}
        onChange={customOnChange}
        onFinalChange={handleRangeOnChange}
        renderTrack={renderTrack}
        renderThumb={renderThumb}
      />
    </div>
  );
};

MinMaxFilter.styles = {
  thumb: {
    alignItems: 'center', // Doesn't work in scss file
  }
};

MinMaxFilter.propTypes = {
  values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  handleRangeOnChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  ref: PropTypes.object
};

export default MinMaxFilter;
